<style scoped>
    .response-info-container {
        z-index:100000; 
        max-height: 500px;
        overflow-y: scroll;
        font-size: .8em; 
    }
    .response-info-container th {
        width: 50px;
    }
</style>
<template>
    <div class="dev-only response-info-container mb-2">
        <div class="mb-1">
            <strong>Response Info</strong>
            <small class="float-right"> <button class="btn btn-sm btn-link" @click="showInfo = !showInfo">{{ (showInfo) ? 'hide' : 'show' }}</button></small>
        </div>
        <div v-if="showInfo">
            <div class="mb-1"><input v-model="filter" class="form-control" placeholder="filter: varname"></div>
            <table class="table table-striped table-bordered table-sm">
                <thead>
                    <tr>
                        <th style="width: 100px;">Variable</th>
                        <th style="width: 50px;">Stored Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(value, variable) in filteredVars">
                        <td>{{ variable }}</td>
                        <td class="text-right">{{ rawResponse[variable] }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="text-muted">
                <small>Wrking value: value</small>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            response: {
                required: true,
                type: Object
            },
            rawResponse: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                filter: '',
                showInfo: false,
                score: []
            }
        },
        computed: {
            filteredVars: function () {
                const exclude = [
                    'survey',
                    'respondent',
                    'last_page',
                    'created_at',
                    'updated_at',
                    'duration',
                    'finalized_at',
                    'started_at',
                    'deleted_at',
                    'respondent_id',
                    'respondent_type',
                    'survey_id',
                    'id'
                ];
                let variables = {};
                for (let variable in this.response) {
                    if (exclude.indexOf(variable) > -1) {
                        continue
                    }
                    if (this.filter !== '' && !variable.includes(this.filter)) {
                        continue
                    }
                    variables[variable] = this.response[variable]
                }
                return variables;
            }
        },
    }
</script>